import React from "react";
import { Body, Main, AccountSelect, Alert } from "./styles"

export default props => {
    const { Option } = AccountSelect;

    return (
        <Body style={props.style}>
            <Main hasError={props.hasError}>
                <label>{props.labelText}</label>
                <AccountSelect
                    id={props.id}
                    name={props.name}
                    value={props.value}
                    defaultValue={props.defaultValue || ''}
                    placeholder={props.placeholder}
                    showSearch={true}
                    filterOption={false}
                    optionFilterProp="children"
                    notFoundContent={null}
                    defaultActiveFirstOption={false}
                    bordered={false}
                    disabled={props.disabled}                 
                    onSearch={props.onSearch}
                    onChange={props.onChange}
                    mode={props.mode}
                >

                    {props.list.map(({value, label}) => (<Option key={value} value={value}>{label}</Option>))}
                </AccountSelect>
            </Main>
            <Alert message={props.message}>
                {props.message ? <span>{props.message}</span> : null}
            </Alert>
        </Body>
    )
}